/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PurchaseOrder } from '../../models/purchase-order';
import { PurchaseOrderComplete } from '../../models/purchase-order-complete';

export interface CompletePurchaseOrder$Params {
  uuid: string;
      body: PurchaseOrderComplete
}

export function completePurchaseOrder(http: HttpClient, rootUrl: string, params: CompletePurchaseOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<PurchaseOrder>> {
  const rb = new RequestBuilder(rootUrl, completePurchaseOrder.PATH, 'patch');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PurchaseOrder>;
    })
  );
}

completePurchaseOrder.PATH = '/purchase-orders/{uuid}/complete';
